import type { NavigateFunction } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useLeagueStore } from './leagueStore';
import { getTenantConfig } from './tenantConfig';
import { getTenantAwarePath } from './tenantStore';
import { useUserStore } from './userStore';

export const TSLH_LEAGUE_ID = getTenantConfig('tslh').leagueId as number;

export function clearLocalUserSession(): void {
  useUserStore.getState().clearUser();
  useLeagueStore.getState().setSelectedLeague(null);
  try {
    window.localStorage.removeItem('remember_me');
    window.localStorage.removeItem('user-storage-tslh');
    window.sessionStorage.removeItem('user-storage-tslh');
    window.localStorage.removeItem('league-storage-tslh');
    window.sessionStorage.removeItem('league-storage-tslh');
  } catch {
    /* ignore storage cleanup errors */
  }
}

export function forceTslhLogout(navigate: NavigateFunction, message?: string): void {
  clearLocalUserSession();
  if (message) toast.error(message);
  navigate(getTenantAwarePath('/auth'), { replace: true });
}